import Bugsnag from '@bugsnag/js';
import { SecureService } from './secureService';
import { Config, WTF3 } from '../utilities/config';
import { Helpers } from '../utilities/helpers';

const { querystring } = Helpers;

class _Service extends SecureService {
  httpReq = async (endpoint, params) => {
    const response = await fetch(`${endpoint}${params}`);
    return response.json ? await response.json() : false;
  };

  // retrieve user by email
  retrieveUser = async (params) => {
    try {
      const response = await fetch(Config.services.user.retrieve, {
        method: 'POST',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
        body: JSON.stringify(params),
      })

      const jsonResponse = await response.json()

      if (jsonResponse.success && jsonResponse.data) {
        const {
          id,
          email,
          first_name,
          last_name,
          motor_policy_number,
          motor_quote_number
        } = jsonResponse.data
        Bugsnag.setUser({
          id,
          email,
          name: `${first_name} ${last_name}`
        })

        // if user already has a motor policy number, run syncPolicy
        // if (motor_policy_number) {
        //   this.syncPolicy(id)
        // } else if (motor_quote_number) {
        //   this.syncPolicy(id, motor_quote_number)
        // }
      }

      return jsonResponse
    } catch (err) {
      console.error('Motor Service: retrieveUser catch(err): ', err)
    }
  };

  processWillLead = async (params) => {
    try {
      const response = await fetch(Config.services.wills.processWillLead, {
        method: 'POST',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
        body: JSON.stringify(params),
      })

      return await response.json()
    } catch (err) {
      console.error('Motor Service: processWillLead catch(err): ', err)
    }
  };

  rewarmWillLead = async (params) => {
    try {
      const response = await fetch(Config.services.wills.rewarmWillLead, {
        method: 'POST',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
        body: JSON.stringify(params),
      })
      return await response.json()
    } catch (err) {
      console.error('Value Added Service: rewarmWillLead catch(err): ', err)
    }
  };

  // process opt in opt out status of user
  processOptInOptOut = async (params) => {
    const response = await fetch(Config.services.user.processOptInOptOut, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    });

    return response.json();
  };

  //send lead to be called

  callLead = async (params) => {
    const response = await fetch(Config.services.user.callLead, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    });

    return response.json();
  };

  // search user by email and contact number
  searchUser = async (params) => {
    const response = await fetch(Config.services.user.searchByField, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    });

    return response.json();
  };

  // send verification SMS to user
  sendSMS = async (user_id, sms_type) => {
    const url = `${Config.services.user.sendSMS.replace(':user_id', user_id)}?sms_type=${sms_type}`
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      }
    })
    return response.json()
  }

  // send verification Email to user
  sendEmail = async (user_id) => {
    const response = await fetch(Config.services.user.sendEmail.replace(':user_id', user_id), {
      method: 'GET',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      }
    })
    return response.json()
  }

  // send SMS to user
  verifySMS = async (params) => {
    const response = await fetch(Config.services.user.verifySMS, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    })
    return response.json()
  }

  // updates an iWyze client
  updateUserOnVerifyAccount = async (userId, params) => {
    const response = await fetch(
      Config.services.user.updateUserOnVerifyAccount.replace(':user_id', userId),
      {
        method: 'PUT',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
        body: JSON.stringify(params),
      }
    )
    return response.json()
  }

  // search for a vehicle make
  searchMake = async (make) => {
    const url = Config.services.vehicle.searchMake.replace('{query}', make);
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    });

    return response.json();
  };

  // search for a vehicle model by make and query string
  searchModel = async (params) => {
    const { make, query, year } = params;
    const url = Config.services.vehicle.searchModel
      .replace('{make}', make)
      .replace('{query}', query)
      .replace('{year}', year);

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    });

    return response.json();
  };

  //search for a vehicle mmcode by query string
  searchMmCode = async (params) => {
    const { query, year } = params;
    const url = Config.services.vehicle.searchMMcode
      .replace('{query}', query)
      .replace('{year}', year);

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    });

    return response.json();
  };

  // get all of a user's vehicles
  getDealershipVehicles = async (params = {}) => {
    const queryStr = querystring(params);
    const url = Config.services.vehicle.getAll.replace(':user_id', params.user_id);

    const response = await fetch(`${url}?${queryStr}`, {
      method: 'GET',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    });

    return await response.json();
  };

  // get all of a user's vehicles
  getVehicles = async (params = {}) => {
    try {
      const queryStr = querystring(params);
      const user_id = await Helpers.getAuthUserId();
      if (!user_id) return { success: false }
      const url = Config.services.vehicle.getAll.replace(':user_id', user_id);

      const response = await fetch(`${url}?${queryStr}`, {
        method: 'GET',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
      });

      return await response.json();
    } catch (err) {
      console.log('Motor Service: getVehicles catch(err)', err.message)
      return {
        success: false,
        error: {
          message: err.message || 'Something went wrong when fetching your vehicles',
        }
      }
    }
  };

  //get users basket
  getBasket = async (params = {}) => {
    try {
      const url = Config.services.vehicle.getVehicleBasket.replace(':user_id', params.id)
      const response = await fetch(`${url}`, {
        method: 'GET',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
      });
  
      if (!response.ok) {
        throw new Error('Failed to fetch basket data');
      }
  
      const result = await response.json();
  
      if (result.success) {
        console.log('Fetched Vehicle Basket:', result.PreviousVehicleBasket); // Handle the successful response
        return result.PreviousVehicleBasket;
      } else {
        throw new Error(result.error.message || 'An error occurred');
      }
    } catch (error) {
      console.error('Error fetching previous basket:', error);
    }
    throw new Error('Failed to fetch basket data');
  };

  // get a vehicle's information from TransUnion using its registration number
  getByReg = async (reg_no, params = {}) =>
    new Promise(async (resolve, reject) => {
      const authHeader = this.generateAuthHeader();
      const controller = new AbortController();
      const signal = controller.signal;
      const user_id = await Helpers.getAuthUserId();
      Object.assign(params, { user_id })

      setTimeout(() => {
        reject({ message: 'Timed out during request' });
        controller.abort();
      }, 15000); // 15 sec

      const url = Config.services.vehicle.getByReg.replace(':reg_no', reg_no)
      fetch(url, {
        method: 'POST',
        headers: {
          ...this.defaultHeaders,
          Authorization: authHeader,
        },
        signal,
        body: JSON.stringify(params),
      })
        .then((response) => {
          response.ok ? resolve(response) : reject(response);
        })
        .catch((err) => {
          reject({ message: 'Timed out during request' });
        });
    })
      .then(function (response) {
        // Request success and no timeout
        return response.json();
      })
      .catch(function (err) {
        // Error: response error, request timeout or runtime error
        let errorObj;

        try {
          errorObj = err.json();
        } catch {}

        return errorObj;
      });

  // find a vehicle in the iWyze collection using its mmcode and year
  getByMmCode = async (params) => {
    const { mmcode, year } = params;

    const response = await fetch(
      Config.services.vehicle.getByMmCode
        .replace(':mmcode', mmcode)
        .replace(':year', year),
      {
        method: 'GET',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
      }
    );

    return await response.json();
  };

  // create an iWyze user vehicle
  createVehicle = async (params) => {
    const response = await fetch(Config.services.vehicle.create, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    });

    return response.json();
  };

  // create an iWyze user vehicle
  deleteVehicle = async (params) => {
    const response = await fetch(Config.services.vehicle.deleteVehicle, {
      method: 'DELETE',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    });

    return response.json();
  };

  // get riskscape place
  getRiskscapePlace = async (coords) => {
    const response = await fetch(
      WTF3.LOOKUP.ADDRESS_LATLNG.replace(':lat', coords.lat).replace(
        ':lng',
        coords.lng
      ),
      {
        method: 'GET',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
      }
    );

    return response.json();
  };

  searchAddress = async (address) => {
    const userId = await Helpers.getAuthUserId()
    const url = `${WTF3.LOOKUP.ADDRESS_AUTOCOMPLETE.replace(':query', address)}&user_id=${userId}`
    try {
      const response = await fetch(
        url,
        {
          headers: {
            ...this.defaultHeaders,
            Authorization: this.generateAuthHeader(),
          },
        }
      );

      const text = await response.text();
      const json = JSON.parse(text);
      return json;
    } catch (err) {
      console.log('Motor Service: searchAddress catch(err)', err)

      return {
        success: false,
        error: {
          message: 'Something went wrong when searching for your address',
        },
      }
    }
  };

  searchCompleteAddress = async (address) => {
    try {
      const userId = await Helpers.getAuthUserId()
      const response = await fetch(WTF3.LOOKUP.ADDRESS_AUTOCOMPLETE_FIELDS,
        {
          method: 'POST',
          headers: {
            ...this.defaultHeaders,
            Authorization: this.generateAuthHeader(),
          },
          body: JSON.stringify({
            ...address,
            user_id: userId,
          }),
        }
      );

      const text = await response.text();
      const json = JSON.parse(text);
      return json;
    } catch (err) {
      console.log('Motor Service: searchCompleteAddress catch(err)', err)

      return {
        success: false,
        error: {
          message: 'Something went wrong when searching for your address',
        },
      }
    }
  };

  searchGoogleAddress = async (address, type) => {
    const response = await fetch(
      Config.services.person.getGoogleAutocomplete
        .replace(':address', address)
        .replace(':type', type),
      {
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
      }
    );

    const text = await response.text();
    const json = JSON.parse(text);

    return json;
  };

  getPlace = async (placeId) => {
    const response = await fetch(
      Config.services.person.getGooglePlace.replace(':placeId', placeId),
      {
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
      }
    );

    return response.json();
  };

  // parse a Google address
  parseGoogleAddress = (address) => {
    const { address_components } = address;
    let suburb, street, number, coords, province, postalCode;

    /*
      zero down on suburb accuracy in this order:
      - sublocality_level_1
      - sublocality_levaddress
      - sublocality
      - locality
    */
    address_components.forEach((component) => {
      if (!suburb && component.types.includes('sublocality_level_1')) {
        suburb = component.long_name;
      }

      if (!suburb && component.types.includes('sublocality_level_2')) {
        suburb = component.long_name;
      }

      if (!suburb && component.types.includes('sublocality')) {
        suburb = component.long_name;
      }

      if (!suburb && component.types.includes('locality')) {
        suburb = component.long_name;
      }

      if (!postalCode && component.types.includes('postal_code')) {
        postalCode = component.long_name;
      }

      // province
      if (
        !province &&
        component.types.includes('administrative_area_level_1')
      ) {
        province = component.long_name;
      }

      // street number
      if (component.types.includes('street_number')) {
        number = component.long_name;
      }

      // street name
      if (component.types.includes('route')) {
        street = component.long_name;
      }
    });

    coords = address.geometry.location;

    if (!street) {
      return {
        success: false,
        error: {
          message: 'Please specify an address with a valid street',
        },
      };
    }

    if (!province) {
      return {
        success: false,
        error: {
          message: 'Please specify an address with a valid province',
        },
      };
    }

    if (!coords || !suburb) {
      return {
        success: false,
        error: {
          message: 'Please specify a valid suburb',
        },
      };
    }

    if (!postalCode) {
      return {
        success: false,
        error: {
          message:
            'The address specified does not seem to have a postal code associated to it. Please be sure to specify an exact street address.',
        },
      };
    }

    return {
      success: true,
      data: {
        street,
        number,
        suburb,
        coords,
        province,
        postal_code: postalCode,
      },
    };
  };

  // get an array of premiums for the vehicle
  getPremiums = async function (params, commit = false, sasria = true) {
    const user_id = await Helpers.getAuthUserId();

    return new Promise((resolve, reject) => {
      const authHeader = this.generateAuthHeader();

      const url = WTF3.QUOTE.UPSERT.replace(':user_id', user_id)
        .replace(':commit', commit)
        .replace(':sasria', sasria);

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: authHeader,
        },
        body: JSON.stringify(params),
      })
        .then((response) => {
          response.ok ? resolve(response) : reject(response);
        })
        .catch((err) => {
          console.log('[getPremiumsService] Get Premiums error:', err)
          setTimeout(() => window.location.reload(), Config.timeLimit.getExcesses)
        })
    })
      .then(function (response) {
        // Request success and no timeout
        return response.json();
      })
      .catch(function (err) {
        // Error: response error, request timeout or runtime error
        let errorObj;
        console.log('- ', err);

        try {
          errorObj = err.json();
        } catch (e) {
          console.log(e);
        }

        return errorObj;
      });
  };

  getBanks = async () => {
    const response = await fetch(Config.services.vehicle.getBanks, {
      method: 'GET',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    });

    return response.json();
  };

  getBranches = async (bank) => {
    const url = `${Config.services.vehicle.getBranches}?bank=${bank}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    });

    return response.json();
  };

  // retrieves a persons information from TransUnion
  getITCPerson = async (id, personType) =>
    new Promise(async (resolve, reject) => {
      const authHeader = this.generateAuthHeader();
      const controller = new AbortController();
      const signal = controller.signal;
      const userId = await Helpers.getAuthUserId();

      setTimeout(() => {
        reject({ message: 'Request timed out' });
        controller.abort();
      }, 15000);

      const url = WTF3.CLIENT.ITC.replace(':za_id', id)
        .replace(':personType', personType)
        .replace(':user_id', userId);

      fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: authHeader,
        },
        signal,
      })
        .then((response) => {
          response.ok ? resolve(response) : reject(response);
        })
        .catch((err) => {
          console.log('[personService] ITC Person error:', err);
        });
    })
      .then(function (response) {
        // Request success and no timeout
        return response.json();
      })
      .catch(function (err) {
        // console.log(err)
        // Error: response error, request timeout or runtime error
        let errorObj;

        try {
          errorObj = err.json();
        } catch (err) { }

        return errorObj;
      });

  // fetch an iWyze person
  getIWYZEPerson = async (id) => {
    const userId = await Helpers.getAuthUserId();
    const response = await fetch(
      Config.services.person.get.replace(
        ':id',
        id && id !== null ? id : userId
      ),
      {
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
      }
    );

    return response.json();
  };

  // fetch an iWyze party person added by user
  getIWYZEAddedPerson = async (id, type = 'REGULAR_DRIVER') => {
    const userId = await Helpers.getAuthUserId();

    const url = Config.services.person.getAddedPerson
      .replace(':user_id', id && id !== null ? id : userId)
      .replace(':type', type);

    const response = await fetch(url, {
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    });

    return response.json();
  };

  createIWYZEPerson = async (params) => {
    try {
      const response = await fetch(Config.services.person.createIWYZEPerson, {
        method: 'POST',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
        body: JSON.stringify(params),
      });

      return response.json();
    } catch (err) {
      console.error(err)
      let errorObj

      try {
        errorObj = error.json()
      } catch (err) { }
      return errorObj
    }
  };

  updateVehicleFinanceDetails = async (params) => {
    const response = await fetch(
      Config.services.vehicle.updateVehicleFinanceDetails.replace(
        ':vehicle_id',
        params.vehicle_id
      ),
      {
        method: 'PUT',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
        body: JSON.stringify(params),
      }
    );

    return response.json();
  };

  addBankDetailsToQuote = async (params) => {
    const userId = await Helpers.getAuthUserId();

    const response = await fetch(
      WTF3.QUOTE.ADD_BANK_DETAILS_TO_QUOTE.replace(':user_id', userId),
      {
        method: 'POST',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
        body: JSON.stringify(params),
      }
    );

    return response.json();
  };

  addAdditionalVehicleToPolicy = async (params) => {
    const userId = await Helpers.getAuthUserId();

    const response = await fetch(Config.services.motorPolicy.create, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    });

    return response.json();
  };

  createPolicy = async (params) => {
    const userId = await Helpers.getAuthUserId();

    const response = await fetch(
      WTF3.QUOTE.CREATE_POLICY.replace(':user_id', userId),
      {
        method: 'POST',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
        body: JSON.stringify(params),
      }
    );

    return response.json();
  };

  getProofOfCover = async (params) => {
    const response = await fetch(Config.services.vehicle.getProofOfCover, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    });
    return response.json();
  };

  getConfig = async () => {
    const response = await fetch(Config.services.vehicle.getConfig, {
      method: 'GET',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    });

    return response.json();
  };

  getTermsAndConditions = async () => {
    const response = await fetch(WTF3.LOOKUP.QUOTE_TCS, {
      method: 'GET',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    });
    return response.json();
  };

  getHomeContentsTermsAndConditions = async () => {
    const response = await fetch(WTF3.LOOKUP.HOME_CONTENTS_TCS, {
      method: 'GET',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    });
    return response.json();
  };

  checkHighRiskVehicle = async (mmcode, year) => {
    const url = WTF3.LOOKUP.HIGH_RISK_VEHICLE.replace(
      ':mmcode',
      mmcode
    ).replace(':year', year);

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    });

    return response.json();
  };

  updateClientDeclarations = async (params) => {
    const userId = await Helpers.getAuthUserId();
    const url = WTF3.CLIENT.UPDATE_DECLARATIONS.replace(':user_id', userId);

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    });

    return response.json();
  };

  // get user excesses
  getExcesses = async () => {
    try {
      const userId = await Helpers.getAuthUserId();

      const url = WTF3.LOOKUP.EXCESSES.replace(':user_id', userId);

      const response = await fetch(url, {
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
      });

      return response.json();
    }
    catch (error) {
      return {
        success: false,
        error
      }
    }
  };

  //
  removeVehicleFromQuote = async (vehicleId) => {
    const userId = await Helpers.getAuthUserId()

    if (!userId) {
      return {
        success: false,
        error: { message: 'No user is currently logged in.' },
      };
    }

    try {
      const response = await fetch(
        WTF3.QUOTE.REMOVE_VEHICLE
          .replace(':userId', userId)
          .replace(':vehicleId', vehicleId),
        {
          method: 'DELETE',
          headers: {
            ...this.defaultHeaders,
            Authorization: this.generateAuthHeader(),
          },
        }
      );
      return await response.json();
    } catch (error) {
      console.log('removeVehicleFromQuote.createPolicy catch(err)', error)

      return {
        success: false,
        error,
      };
    }
  }

  // remove object from quote
  removeObjectFromQuote = async (objectNo) => {
    const userId = await Helpers.getAuthUserId();

    if (!userId) {
      return {
        success: false,
        error: { message: 'No user is currently logged in.' },
      };
    }

    try {
      const response = await fetch(
        WTF3.QUOTE.REMOVE_OBJECT.replace(':user_id', userId).replace(
          ':object_no',
          objectNo
        ),
        {
          method: 'DELETE',
          headers: {
            ...this.defaultHeaders,
            Authorization: this.generateAuthHeader(),
          },
        }
      );
      return await response.json();
    } catch (error) {
      console.log('removeObjectFromQuote.createPolicy catch(err)', error);

      return {
        success: false,
        error,
      }
    }
  }

  sendIntercomTag = async (intercomTag) => {
    const user_id = await Helpers.getAuthUserId();
    const params = {
      user_id,
      intercomTags: intercomTag,
    };

    const response = await fetch(Config.services.vehicle.sendIntercomTags, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    })

    return response.json()
  };

  sendIntercomEvent = async (eventName, metadata = {}) => {
    const user_id = await Helpers.getAuthUserId();
    const params = {
      user_id,
      eventName,
      metadata,
    };

    const response = await fetch(Config.services.vehicle.sendIntercomEvent, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    });

    return response.json()
  };

  syncPolicy = async (user_id, policyNumber) => {
    if (user_id) {
      let url = Config.services.motorPolicy.sync.replace(':user_id', user_id)

      if (policyNumber) {
        url = `${url}?force=${policyNumber}`
      }

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            ...this.defaultHeaders,
            Authorization: this.generateAuthHeader(),
          },
        });

        return response.json()

      } catch (err) {
        console.log('[motorPolicyService] Sync Policy error:', err)
        return {
          success: false,
          error: {
            message: 'Unable to sync motor policy.',
          }
        }
      }
    }
  }

  // Generate verification code for agent
  generateAgentVerificationCode = async (agent_id) => {
    try {
      const url = Config.services.agent.generateAgentVerificationCode.replace(':agent_id', agent_id)

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        }
      });

      return response.json();
    } catch (err) {
      console.error('generateAgentVerificationCode error:', err);
      return {
        success: false,
        error: {
          message: 'Unable to generate verification code.',
        }
      };
    }
  }

  // Verify agent code
  verifyAgentCode = async (code, agent_id) => {
    try {
      const url = Config.services.agent.verifyAgentCode

      const params = {
        agent_id,
        code
      }

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
        body: JSON.stringify(params)
      });

      return response.json();
    } catch (err) {
      console.error('[motorService] verifyAgentCode error:', err);
      return {
        success: false,
        error: {
          message: 'Unable to verify code.',
        }
      };
    }
  }

  // get sales agent
  retrieveSalesAgent = async (params) => {
    const response = await fetch(Config.services.user.retrieveSalesAgent, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    })

    return response.json()
  };

  updateVin = async (vinNo, vehicleId) => {
    const user_id = await Helpers.getAuthUserId();

    const params = {
      user_id,
      vehicleId,
      vinNo,
    };

    const response = await fetch(Config.services.vehicle.updateVin, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    });

    return response.json();
  }

  // log Google Conversion
  logGoogleConversion = async (params) => {
    const response = await fetch(Config.services.analytics.googleConversion, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    })

    return response.json()
  }

  verifyEmail = async (userId, verifyEmailAddress) => {
    const url = Config.services.user.verifyEmail.replace(':user_id', userId) + `?v=${verifyEmailAddress}`
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    })
    return response.json()
  }

  recollectionsReschedule = async (params) => {
    const response = await fetch(Config.services.recollections.schedule, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    })

    return await response.json()
  }

  // search for finance house
  searchFinanceHouse = async (financeHouse) => {
    const url = Config.services.vehicle.searchFinanceHouse.replace('{query}', financeHouse)
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    })

    return await response.json()
  }

  getFinanceHouseName = async (financeHouseCode) => {
    const url = Config.services.vehicle.getFinanceHouseName.replace('{code}', financeHouseCode)
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    })

    return await response.json()
  }

  getInsurerList = async () => {
    const url = Config.services.vehicle.getInsurerList
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
    })

    return await response.json()
  }

  updateVehicleMTA = async (params) => {
    const url = Config.services.vehicle.MTA
    const userId = await Helpers.getAuthUserId()

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify({
        ...params,
        user_id: userId
      })
    })

    return await response.json()
  }
}

const MotorService = new _Service();
export { MotorService };
